<template>
  <v-content>
    <v-list-item avatar 
      @click="open(`http://nijisanji.ichikara.co.jp/member/${liver.roman}`)" 
      :style="{ background: `linear-gradient(#FFFFFF, ${liver.color})`}" 
      :key="liver.id">
      <v-list-item-avatar height="80px" width="80px"><img :src="`https://wikiwiki.jp/nijisanji/?plugin=ref&page=${liver.name}&src=face.png`" alt=""/></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title">{{liver.name}}</v-list-item-title>
        <v-list-item-subtitle class="subheading">
          <v-btn class="img-btn" text small icon v-for="site in liver.sites" @click.stop="openSite(site)" :key="site.name"><img class="liver-app-logo" :src="logoUrl(site.type)" alt=""/></v-btn>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action @click.stop="toggleFavorite(liver.id)">
        <v-list-item-action-text>推し</v-list-item-action-text>
        <v-icon v-if="!isFavorite" color="grey lighten-1">star_border</v-icon>
        <v-icon v-else color="yellow">star</v-icon>           
      </v-list-item-action>
    </v-list-item>

    <v-dialog v-model="showYoutubeDialog">
      <v-card>
        <v-card-title primary-title>オプション</v-card-title>
        <v-list>
          <v-list-item>
            <v-list-item-content @click="open(selectedSite.url)">
              <v-list-item-title>チャンネル</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content @click="open(selectedSite.liveUrl)">
              <v-list-item-title>待機場所</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<style scoped>
  .v-content {
    padding: 0px !important;
  }

  .liver-subheader-view {
    background-color: #6CBFEB;
    color: #FFFFFF !important;
    font-weight: bold !important;
  }

  .liver-app-logo {
    vertical-align: middle;
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .img-btn {
    min-width: auto !important;
    height: auto !important;
    padding: 0px !important;
    margin: 8px;
  }
</style>

<script>
import store from '@/util/store.js'
import { logo } from '@/util/config.js'

export default {
  props: {
    liver: Object
  },
  data: () => ({
    isFavorite: false,
    showYoutubeDialog: false,
    selectedSite: null,
  }),
  computed: {
    favoriteLivers() {
      return store.state.favoriteLivers;
    }
  },
  mounted() {
    this.isFavorite = this.favoriteLivers[this.liver.id];
  },
  methods: {
    openSite: function(site) {
      if(site.type == "Youtube") {
        this.selectedSite = site;
        this.showYoutubeDialog = true;
      } else {
        window.open(site.url, "_blank")
      }
    },
    toggleFavorite: function(id) {
      this.isFavorite = !this.isFavorite;
      store.commit('setFavorite', {id: this.liver.id, isFavorite: this.isFavorite});
    },
    logoUrl: v =>  `/img/${logo[v]}`,
    open: url => window.open(url, "_blank")
  }
}
</script>